import React from 'react';
import { EnelXGuiAtoms } from 'gui';
import PropTypes from 'prop-types';

const {
  MigrationSingleInputV2,
} = EnelXGuiAtoms;

const MainInput = ({
  errorMessage,
  ...props
}) => (
  <MigrationSingleInputV2
    {...(errorMessage ? {
      message: {
        type: 'error',
        textLeft: errorMessage,
      },
    } : {})}
    {...props}
  />
);

MainInput.defaultProps = {
  borderColor: null,
  disabled: false,
  errorMessage: null,
  externalComponent: null,
  label: '',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  placeholder: '',
  type: 'text',
  value: '',
};

MainInput.propTypes = {
  borderColor: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  externalComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
};

MainInput.displayName = 'MainInput';

export default MainInput;
